<!-- Alert Section -->
@if (alertMessage()) {
  <div class="alert alert-warning alert-dismissible fade show m-0 rounded-0" role="alert">
    <div class="container">
      <div class="d-flex align-items-center">
        <i class="bi bi-exclamation-triangle me-3"></i>
        <span>{{ alertMessage() }}</span>
        <button
          type="button"
          class="btn-close ms-auto"
          [attr.aria-label]="'landingPage.closeAlert' | transloco"
          (click)="closeAlert()"
          (keydown.enter)="closeAlert()"
          (keydown.escape)="closeAlert()"
        ></button>
      </div>
    </div>
  </div>
}

<!-- Hero Section -->
<section class="hero-section bg-gradient-primary text-white">
  <div class="w-100 container-landing-page d-flex align-items-center">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="text-center fade-in-right p-5">
          <img
            src="images/logos/logo-company.png"
            [attr.alt]="'landingPage.logoAlt' | transloco"
            class="img-fluid p-3"
          />
        </div>
      </div>
      <div class="col-lg-6">
        <h1 class="display-4 fw-bold mb-4 fade-in-up">
          {{ 'landingPage.heroTitle' | transloco }}
        </h1>
        <p class="lead mb-4 fade-in-up animation-delay-1">
          {{ 'landingPage.heroDescription' | transloco }}
        </p>
        <div class="btns-landing-page d-flex flex-wrap gap-3 fade-in-up animation-delay-2">
          <a routerLink="/register" class="btn btn-primary btn-lg px-4 py-3 fw-semibold">
            <i class="bi bi-rocket-takeoff me-2"></i>
            {{ 'landingPage.primaryAction' | transloco }}
          </a>
          <a routerLink="/login" class="btn btn-outline-light btn-lg px-4 py-3">
            <i class="bi bi-box-arrow-in-right me-2"></i>
            {{ 'landingPage.secondaryAction' | transloco }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
